import type { Form, Stored } from "@overmap-ai/common"
import { Mention } from "@tiptap/extension-mention"
import { mergeAttributes, ReactNodeViewRenderer } from "@tiptap/react"

import type { MentionOptions } from "../typings"
import { FormMentionComponent } from "./Component"
import { suggestion } from "./suggestion"

export const FormMention = Mention.extend<MentionOptions<Stored<Form>>>({
	name: "FormMention",
	atom: true,
	addAttributes() {
		return {
			uuid: {
				default: null,
			},
		}
	},
	parseHTML() {
		return [
			{
				tag: "form-mention",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["form-mention", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(FormMentionComponent)
	},
}).configure({
	suggestion,
})
